export const ADMIN_SIGNIN_REQUEST = 'admin/auth/SIGNIN_REQUEST';
export const ADMIN_SIGNIN_SUCCESS = 'admin/auth/SIGNIN_SUCCESS';
export const ADMIN_SIGNIN_FAILURE = 'admin/auth/SIGNIN_FAILURE';
export const ADMIN_SIGNOUT_USER = 'admin/auth/SIGNOUT_USER';

export const ADMIN_PROFILE_REQUEST = 'admin/auth/PROFILE_REQUEST';
export const ADMIN_PROFILE_SUCCESS = 'admin/auth/PROFILE_SUCCESS';
export const ADMIN_PROFILE_FAILURE = 'admin/auth/PROFILE_FAILURE';

export const ADMIN_PASSWORD_UPDATE_REQUEST = 'admin/auth/PASSWORD_UPDATE_REQUEST';
export const ADMIN_PASSWORD_UPDATE_SUCCESS = 'admin/auth/PASSWORD_UPDATE_SUCCESS';
export const ADMIN_PASSWORD_UPDATE_FAILURE = 'admin/auth/PASSWORD_UPDATE_FAILURE';

export const ADMIN_TYPES_REQUEST = 'admin/TYPES_REQUEST';
export const ADMIN_TYPES_SUCCESS = 'admin/TYPES_SUCCESS';
export const ADMIN_TYPES_FAILURE = 'admin/TYPES_FAILURE';
